export default "__VITE_ASSET__BnGgq5xQ__"